<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 16:05:11
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 11:39:09
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 16:02:34
 * @LastEditors: lau
 * @LastEditTime: 2022-08-22 16:03:59
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 15:58:11
 * @LastEditors: lau
 * @LastEditTime: 2022-08-22 16:00:45
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 15:30:50
 * @LastEditors: lau
 * @LastEditTime: 2022-08-22 15:33:28
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 09:10:08
 * @LastEditors: lau
 * @LastEditTime: 2022-08-22 09:15:38
-->

<!-- 根据根据券模版代码查询券模版信息接口内容 -->
<template>
	<div class="">
		<right-structure :Pdatas='infoData'>
			<pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
			<pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
		</right-structure>
	</div>
</template>

<script>
	import structure from "@/components/commonStructure"

	export default {
		name: '',
		components: {
			'right-structure': structure,
		},
		props: ['commonUrls'],
		data() {
			return {
				requestBody: {
				},
				responseCode: {
					"data": {
						"couponCode":""
					},
					"message": "业务成功",
					"resultCode": 0,
					"status": 1
				},
				infoData: {
					explain: "第三方接入系统请求智慧停车开放平台根据券编码查询电子券适用车场",
					t_url: this.commonUrls.test + "queryCouponAvailableParkByCouponCode",
					p_url: this.commonUrls.prod + "queryCouponAvailableParkByCouponCode",
					precondition: "无",
					fitSystem: "VEMS传统停车场，云停车场",
					pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
					Q_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
							{info1: 'couponCode',info2: '是',info3: 'String',info4: '优惠券编码'},
							{info1: 'fixedStatus',info2: '是',info3: 'Long',info4: '固定状态：0 非固定券，1 固定券(默认为0)'},

					 ]
					}],
					R_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [ 
									{ info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前数量' },
									{ info1: 'recordList', info2: '是', info3: 'Integer', info4: '记录列表' },

						]
					},{
						titleName: "recordList",
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [ 
									{ info1: 'address', info2: '是', info3: 'String', info4: '地址' },
									{ info1: 'desc', info2: '是', info3: 'String', info4: '描述' },
									{ info1: 'eptCarports', info2: '是', info3: 'Integer', info4: '空车位' },
									{ info1: 'latitude', info2: '是', info3: 'String', info4: '维度' },
									{ info1: 'longitude', info2: '是', info3: 'String', info4: '经度' },
									{ info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编号' },
									{ info1: 'parkId', info2: '是', info3: 'Long', info4: '车场id' },
									{ info1: 'parkName', info2: '是', info3: 'String', info4: '车场名称' },
									{ info1: 'parkSysType', info2: '是', info3: 'Integer', info4: '车场类型' },
									{ info1: 'parkUUID', info2: '是', info3: 'String', info4: '车场uuid' },
									{ info1: 'totalCarports', info2: '是', info3: 'Integer', info4: '总车位' },
									{ info1: 'conTel', info2: '是', info3: 'String', info4: '联系电话' },
									{ info1: 'mobileInventoryExpirationTime', info2: '否', info3: 'Integer', info4: '移动盘点到期时间,yyyyMMddHHmmss' },
									{ info1: 'mobilePatrolExpirationTime', info2: '否', info3: 'Integer', info4: '移动巡场到期时间,yyyyMMddHHmmss' },
									{ info1: 'versionSupport', info2: '否', info3: 'Boolean', info4: '版本是否支持(false:不支持,true:支持)' },

						]
					}],
					codeStatus: [{
						titleName: null,
						tabledata: [{
							tableHead: '状态码',
							tdName: 'info1'
						}, {
							tableHead: '说明',
							tdName: 'info2'
						}],
						td: [{
							info1: '000110',
							info2: '失败',
						}, {
							info1: '00110000',
							info2: '失败',
						}, {
							info1: '110000',
							info2: '失败',
						}]
					}],
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/queryCouponAvailableParkByCouponCode.vue